{
    "common": {
        "mon": "周一",
        "tue": "周二",
        "wed": "周三",
        "thu": "周四",
        "fri": "周五",
        "sat": "周六",
        "sun": "周日",
        "jan": "1月",
        "feb": "2月",
        "mar": "3月",
        "apr": "4月",        
        "jun": "6月",
        "jul": "7月",
        "aug": "8月",
        "sep": "9月",
        "oct": "10月",
        "nov": "11月",
        "dec": "12月",
        "january": "一月",
        "february": "二月",
        "march": "三月",
        "april": "四月",
        "may": "五月",
        "june": "六月",
        "july": "七月",
        "august": "八月", 
        "september": "九月",
        "october": "十月",
        "november": "十一月",
        "december": "十二月",
        "checkin": "入住",
        "checkout": "退房",
        "room": "房间",
        "rooms": "房间",
        "adult": "成人",
        "adults": "成人",
        "edit": "编辑",
        "editCap": "编辑",
        "delete": "删除",
        "deleteCap": "删除",
        "localTime": "当地时间",
        "back": "返回",
        "home": "首页",
        "yes": "是",
        "no": "否",
        "left": "剩余",
        "hour": "小时",
        "hours": "小时",
        "night": "晚",
        "nights": "晚",
        "for": "为",
        "why": "为什么",
        "get": "获取",
        "more": "更多",
        "agree": "同意",
        "disagree": "不同意",
        "basedOn": "基于",
        "error": "发生错误，请稍后重试",
        "error2": "失败，请重试！",
        "error3": "发生错误！！",
        "error4": "发生错误！！请重试",
        "error5": "抱歉！！发生了一些错误。请稍后重试。",
        "hi": "您好",
        "to": "至",
        "free": "免费",
        "per": "每",
        "at": "在",
        "day": "天",
        "days": "天",
        "time": "时间",
        "of": "的",
        "photo": "照片",
        "photos": "照片",
        "done": "完成",
        "fullStay": "全程住宿",
        "date": "日期",
        "and": "和",
        "bookingDetail": "预订详情",
        "Back": "返回",
        "Home": "首页"
    },
    "userPopup": {
        "myAccount": "我的账户",
        "welcome": "欢迎",
        "user": "用户",
        "findMyBookings": "查找我的预订",
        "viewProfile": "查看个人资料",
        "makeAReservarion": "进行预订",
        "logout": "退出登录",
        "loginCap": "登录",
        "login": "登录",
        "invalidCredentials": "无效的凭证",
        "invalidEmail": "无效的电子邮件",
        "passwordIsRequired": "密码是必填项",
        "minChar8": "最少8个字符",
        "tooShort": "太短了！",
        "tooLong": "太长了！",
        "required": "必填",
        "emailInvalid": "请输入有效的电子邮件",
        "passwordInvalid": "请输入有效的密码",
        "phNumInvalid": "电话号码无效",
        "signupCap": "注册",
        "signup": "注册",
        "verifyText": "验证您的身份",
        "verifyText2": "我们已向您的电子邮件发送了验证码",
        "verificationCode": "验证码",
        "didNotReceiveEmail": "没有收到电子邮件",
        "clickToResend": "点击重新发送",
        "verifyAndSignIn": "验证并登录",
        "otpSentSuccessfully": "验证码发送成功",
        "somethingWentWrong": "出了点问题，请重试",
        "otpError": "请输入有效的数字",
        "otpError2": "请只输入数字",
        "otpError3": "验证码错误，请重试",
        "otpError4": "验证码已过期，点击重新发送",
        "otpError5": "请重试",
        "forgetPassword": "忘记密码",
        "submitError": "用户不存在！",
        "userExistError": "用户已存在",
        "checkYourEmail": "请检查您的电子邮件",
        "passwordResetLinkSent": "我们已将密码重置链接发送至",
        "noWorriesResetInstructions": "别担心，我们会向您发送重置说明。",
        "enterYourEmail": "输入您的电子邮件",
        "resetMyPassword": "重置密码",
        "setANewPassword": "设置新密码",
        "newPassword": "新密码",
        "confirmPassword": "确认密码",
        "confirmPasswordError": "密码必须匹配",
        "backToLogin": "返回登录",
        "dontHaveAccount": "没有账户？",
        "alreadyHaveAccount": "已有账户？",
        "memberDiscount1": "您将获得",
        "memberDiscount2": "永久会员折扣。",
        "discount1": "在一个地方管理您的所有预订。",
        "discount2": "注册获取个性化推荐和定制体验！！",
        "discount3": "加入我们快乐宾客社区，开始规划您的住宿。",
        "leftGridText1": "在一个地方管理您的所有预订",
        "leftGridText2": "注册获取个性化推荐和定制体验！！",
        "leftGridText3": "加入我们快乐宾客社区，开始规划您的住宿",
        "gridDiscountText1": "会员折扣",
        "gridDiscountText2": "永久精选房源",
        "gridDiscountText3": "登录享受永久定制体验",
        "gridDiscountText4": "获取专属会员优惠",
        "findBookingError": "您的电子邮件和预订ID不匹配",
        "verifyAndConfirmBooking": "验证并确认预订",
        "confirmEmailText": "我们已向您的电子邮件地址发送了验证码",
        "enterCodeText": "请输入发送给您的验证码",
        "didNotRecieveEmail": "没有收到电子邮件？",
        "changeEmailText": "点击此处更改电子邮件地址",
        "verifyAndConfirm": "验证并确认",
        "verified": "已验证",
        "bookingExpired": "预订已过期",
        "bookingExpiredText": "抱歉，您使用的预订ID已过期",
        "backToFindingBooking": "返回查找预订",
        "findMyBooking": "查找我的预订",
        "bookingEmail": "预订电子邮件",
        "reservationId": "预订ID",
        "findBooking": "查找预订",
        "abandonmentCartDoneText1": "谢谢！",
        "abandonmentCartDoneText2": "您的购物车详情已发送至电子邮件。随时继续您的预订。",
        "Recommended Currencies": "推荐货币",
        "All currencies": "所有货币",
        "thisIsRequiredField": "此为必填项"
    },
    "widget": {
        "destination": "目的地",
        "enterDestination": "输入目的地",
        "guests": "客人",
        "guest": "客人",
        "nationality": "国籍",
        "selectNationality": "选择国籍",
        "nationalityIsRequired": "国籍为必填项",
        "selectedRate": "特殊价格",
        "search": "搜索",
        "ages": "年龄",
        "orAbove": "或以上",
        "child": "儿童",
        "children": "儿童",
        "addAnotherRoom": "添加另一个房间",
        "removeRoom": "移除房间",
        "property": "房源",
        "city": "城市",
        "country": "国家",
        "bookNow": "立即预订",
        "overnightStay": "过夜住宿",
        "dayUse": "日间使用",
        "destinationIsRequired": "目的地是必填项",
        "checkInIsRequired": "入住日期是必填项",
        "checkOutIsRequired": "退房日期是必填项",
        "noLocationFound": "未找到位置",
        "soldOut": "已售罄",
        "highDemand": "高需求",
        "dates": "日期",
        "allRates": "所有价格均以",
        "K": "千",
        "M": "百万",
        "sameDayCheckout": "当天退房"
    },
    "promotion": {
        "headingText": "重要信息",
        "regularRate": "无",
        "seniorCitizen": "老年人价格",
        "agencyRate": "代理价格",
        "caaRate": "CAA/AAA价格",
        "corporateRate": "企业价格",
        "governmentRate": "政府/军人价格",
        "promotionalSpecialRate": "促销/特别价格",
        "regularRateDescription": "未应用任何促销活动。",
        "seniorCitizenRateDescription": "这是广泛提供给老年人的酒店折扣价格，通常适用于60岁或以上的人群。",
        "agencyRateDescription": "这是一种酒店折扣价格，只能通过特定旅行社访问，以促进合作伙伴关系和协作。",
        "caaRateDescription": "这是为AAA或CAA会员提供的特殊酒店价格，享受专属优惠。",
        "corporateRateDescription": "这是为商务旅客提供的酒店折扣价格，通常由酒店和企业实体协商确定。",
        "governmentRateDescription": "此价格计划为政府/军事人员预订酒店房间提供特定折扣。",
        "contentSeniorCitizen": "入住时必须出示出生日期证明。未能出示相关身份证件将按现行价格收费。",
        "contentAgencyRate": "请确保到达时携带预订确认书和身份证明。未能出示这些将按标准价格收费。",
        "contentPromotionalSpecialRate": "这是限时提供的酒店折扣价格，通常与特定活动、季节或营销活动相关。",
        "contentCaaRate": "请确保在入住时携带您的CAA会员卡或相关身份证明。未能出示相关证件将按现行价格收费。",
        "contentCorporateRate": "入住时需要提供公司身份证明或其他官方文件。未能提供相关证明将按现行价格收费。",
        "contentGovernmentRate": "入住时必须提供有效的政府或军人身份证件。未能提供所需身份证明将按标准价格收费。",
        "CORP": "企业",
        "AGEN": "代理",
        "PROM": "促销",
        "apply": "应用",
        "Offer Code": "优惠码",
        "Agency Code": "代理码",
        "Corporate Code": "企业码",
        "All-Access Rate": "全通价格",
        "errorCode": "此代码无效"
    }
}
